import { render, staticRenderFns } from "./DwzxbgsqForm.vue?vue&type=template&id=a0e4a932&scoped=true"
import script from "./DwzxbgsqForm.vue?vue&type=script&lang=js"
export * from "./DwzxbgsqForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e4a932",
  null
  
)

export default component.exports